<template>
   <v-container pt-2>
      <v-layout column>
         <a-select-field clearable label="Situação" multiple
                         obj="allowedStatus" ref="statusField" return-object v-model="filterData.statusId"></a-select-field>

         <a-autocomplete-field clearable label="Cliente" obj="client"
                               placeholder="selecionar cliente" ref="clientField"
                               v-model="filterData.clientId">
            <template slot="content" slot-scope="{data}">
               <v-layout column>
                  <v-list-tile-title style="height: 18px;" v-text="data.name"></v-list-tile-title>
                  <v-list-tile-sub-title class="py-0">
                     {{`${data.federalId} (${data.city}/${data.state})`}}
                  </v-list-tile-sub-title>
               </v-layout>
            </template>
         </a-autocomplete-field>

         <a-autocomplete-field autoTrigger clearable label="Banco" obj="bank" ref="bankField"
         v-model="filterData.bankId"></a-autocomplete-field>
         
         <a-select-field 
               clearable label="Convênio" 
               obj="covenant" sm4 v-model="filterData.covenantId"
               ref="covenantField"
         ></a-select-field>

         <a-select-field 
               clearable label="Por Afiliado" 
               obj="affiliate" objMethod="getMyBrandAffiliates" sm4
               v-model="filterData.affiliateId"
               ref="affiliateField"
         ></a-select-field>

         <a-select-field 
               clearable label="Por Link de Campanha" 
               :filter-by="{affiliateId: filterData.affiliateId}"
               obj="campaign" objMethod="getMyBrandLinks" sm4
               v-model="filterData.campaignLinkId"
               updateWithFilters
               ref="campaignLinkField"
         ></a-select-field>

         <a-date-field clearable dateFormat="DD/MM/YYYY" label="Data entre" rid="workflow.dateRange"
                       v-model="filterData.dateRange[0]" validate="dateDMY" xs12></a-date-field>
         <a-date-field clearable dateFormat="DD/MM/YYYY" label="e" rid="workflow.dateRange"
                       v-model="filterData.dateRange[1]" validate="dateDMY" xs12></a-date-field>

         <a-select-field clearable label="Produto" obj="productType"
               v-model="filterData.productTypeId" ref="productTypeField"></a-select-field>

      </v-layout>
   </v-container>
</template>

<script>

   export default {

      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data () {
         return {
            filterData: {
               storeId: null,
               statusId: null,
               clientId: null,
               typeId: null,
               covenantId: null,
               bankId: null,
               dateRange: [null, null],
               affiliateId: null,
               campaignLinkId: null,
               productTypeId: null,
            },
         };
      },

      computed: {
         kind () {
            return this.$route.meta.filterProps && this.$route.meta.filterProps.kind ? this.$route.meta.filterProps.kind : null;
         }
      },


      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute (val) {
            val && this.applyFilter();
         }
      },

      methods: {
         applyFilter () {
            let filters = [];

            let rangeLabel = '';
            if (this.filterData.dateRange) {
               let dateRange = this.filterData.dateRange.filter(d => d !== null);
               dateRange.forEach((v, i) => dateRange[i] = this.$moment(v).format('YYYY-MM-DD'));

               if (dateRange.length === 2)
                  rangeLabel += (dateRange[0] === dateRange[1]) ? 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY') : `Entre ${this.$moment(dateRange[0]).format('DD/MM/YYYY')} e ${this.$moment(dateRange[1]).format('DD/MM/YYYY')} `;
               else if (dateRange.length)
                  rangeLabel += 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY');
               else
                  rangeLabel = '';

               if (!rangeLabel) {
                  this.filterData.dateRange = [null, null];
               }
            }

            filters.push({field: 'dateRange', value: this.filterData.dateRange, label: rangeLabel});

            filters.push({
               field: 'clientId',
               value: this.filterData.clientId,
               label: this.$refs.clientField.selectedText
            });
            filters.push({
               field: 'bankId',
               value: this.filterData.bankId,
               label: this.$refs.bankField.selectedText
            });

            filters.push({
               field: 'covenantId',
               value: this.filterData.covenantId,
               label: this.$refs.covenantField.selectedText
            });

            let statusLabels = [];
            let statusKeys = [];
            if (this.filterData.statusId) {
               this.filterData.statusId.forEach(s => {
                  statusKeys.push(s.id);
                  statusLabels.push(s.name);
               });
            }
            let statusFilterLabel = (this.$refs.statusField.items.length === statusKeys.length) ? 'Sit.: Todas' : 'Sit.: ' + statusLabels.join(', ');
            filters.push({
               field: 'statusId',
               value: statusKeys.join(),
               label: statusFilterLabel
            });

            filters.push({
               field: 'storeId',
               value: this.$store.state.company.selectedStore,
               label: this.$store.state.company.selectedStoreName
            });

            let affiliateName;
            if(this.filterData.affiliateId  && this.$refs.affiliateField && this.$refs.affiliateField.items.length){
               let auxText = this.$refs.affiliateField.items.find(el => el.id == this.filterData.affiliateId);
               affiliateName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'affiliateId', value: this.filterData.affiliateId, label: affiliateName});

            let campaignLinkName;
            if(this.filterData.campaignLinkId  && this.$refs.campaignLinkField && this.$refs.campaignLinkField.items.length){
               let auxText = this.$refs.campaignLinkField.items.find(el => el.id == this.filterData.campaignLinkId);
               campaignLinkName = auxText && auxText.name ? auxText.name : null
            }

            filters.push({field: 'campaignLinkId', value: this.filterData.campaignLinkId, label: campaignLinkName});

            let productTypeName;
            this.filterData.productTypeId ? productTypeName = this.$refs.productTypeField.items.find(el => el.id == this.filterData.productTypeId).name : productTypeName = null;
            filters.push({ field: 'productTypeId', value: this.filterData.productTypeId, label: productTypeName });

            this.$store.dispatch('updateAllPageFilters', filters);

            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters () {
            this.$util.updateObj(this.filterData, this.$store.getters.activePageFilters);

            if (!this.filterData.dateRange) {
               this.filterData.dateRange = [null, null];
            }
         }
      },
   };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ProductionFilter.vue